export function units(value: number): string {
  return value.toLocaleString("en-US")
}

const DAY = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", timeZone: "UTC" })
const DAY_WITH_YEAR = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" })

// "Oct 12", with the year added when it is not the current one.
export function shortDate(iso: string, today: string): string {
  const date = new Date(`${iso}T00:00:00Z`)
  return iso.slice(0, 4) === today.slice(0, 4) ? DAY.format(date) : DAY_WITH_YEAR.format(date)
}
